var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-date-range-picker',_vm._b({on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"activator",fn:function(props){return [_vm._t("activator",null,null,props)]}}],null,true),model:{value:(_vm.innerDate),callback:function ($$v) {_vm.innerDate=$$v},expression:"innerDate"}},'ui-date-range-picker',_vm.datePickerSettings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }